
  import {mapSectionComponents} from '@/helper/SectionHelper';
  import {getMetaTags} from '@/helper/Seo';
  import LazyHydrate from 'vue-lazy-hydration';
  import {scopeHelper} from '@/helper/ScopeHelper';

  export default {
    name: 'LandingPageMessejobs',
    components: {
      LazyHydrate,
    },
    async asyncData({app, error, $cachedStrapi, $growthbook, store}) {
      // Add grothbook to test different landingpage-variations
      let slug;
      switch ($growthbook.getFeatureValue('cro_landingpage_messejobs')) {
        case 'v1':
          slug = 'landingpages-messejobs-cro-v1';
          break;

        default:
          slug = 'landingpages-messejobs';
      }

      // Query page from Strapi; strapi-change for findOne is required!
      const page = await $cachedStrapi.findOne('pages', slug).catch((e) => {
        if (e.statusCode !== 404) {
          throw e;
        }
      });

      if (!scopeHelper(page, process.env.SCOPE_CANDIDATE)) {
        error({statusCode: 404, message: 'Page not found'});
        return;
      }

      // Get number from cache
      let numberOfJobs = await store.dispatch(
        'api/jobPosting/getLandingpageJobPostingsTotalNumber',
        'job-posting-number-messejobs'
      );
      numberOfJobs = numberOfJobs
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

      const sections = await mapSectionComponents(
        page.sections,
        async function (section) {
          switch (section.component) {
            case 'SectionBreadcrumbs':
              section.breadcrumbs = [
                {
                  text: app.i18n.t('page.index'),
                  disabled: false,
                  to: app.localePath({
                    name: 'index',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: app.i18n.t('page.landingpage_messejobs'),
                  disabled: true,
                  to: app.localePath({
                    name: 'landingpages-messejobs',
                  }),
                  nuxt: true,
                  exact: true,
                },
              ];
              break;

            case 'SectionLandingPageHero':
              // Set number in section
              section.numberOfJobs = numberOfJobs;
              break;

            case 'SectionSeoContent':
              if (
                section.seo_content_config &&
                section.seo_content_config.seo_contents &&
                section.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  section.seo_content_config.seo_contents[0].id
                );
              }
              break;
          }
        }
      );

      const metaData = page && page.meta ? page.meta : {};

      return {
        metaData,
        sections,
      };
    },
    data() {
      return {
        metaData: {},
        sections: [],
      };
    },
    head() {
      return {
        title: this.metaData.title,
        meta: getMetaTags(this.metaData),
      };
    },
    mounted() {
      // Aufruf im CSR für Tracking-Callback
      this.$growthbook.getFeatureValue('cro_landingpage_messejobs');
    },
  };
